import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useFormik, FormikProvider } from "formik";
import { IReviewBookingDetails } from "./reviewbookingModel";
import {
  getGroupwiseTravellerByUserID,
  getAirlineReprice,
  getSeatMap,
  getSSRList,
  getHandlingFees,
  getPromoCodeDetails,
  getChargesByMembershipPlan,
  reedemGiftCodeForBooking,
  verifyGiftCodeOtp,
} from "./services/reviewbooking.services";
import { ErrorToast, SuccessToast } from "../../toast/Toasts";
import Loading from "../../components/spinner/Loading";
import ReviewFlightRouteCard from "./ReviewFlightRouteCard";
import ReviewPriceCard from "./ReviewPriceCard";
import IMPInfoCard from "./IMPInfoCard";
import AdultForm from "./AdultForm";
import ChildForm from "./ChildForm";
import InfantForm from "./InfantForm";
import ContactDetailsForm from "./ContactDetailsForm";
import { getAllActiveCountries } from "../country/services/country.services";
import moment from "moment";
import {
  AGENCY_NUMBER,
  MAX_PAN_REQUIRED_AMOUNT,
} from "../../_constants/constant";
import ReviewBookingSummary from "./ReviewBookingSummary";
import {
  getBillingDetails,
  // getLoginDetailsByID,
} from "../myprofile/services/myprofile.services";
import PanInfoCard from "./PanInfoCard";
import { debounce } from "lodash";
import axios from "axios";
import AddOnsCard from "./AddOnsCard";
import { isInternationalFlight } from "../../_helpers/flightUtils";
import {
  calculateFareDetails,
  calculateGiftCodeDiscount,
  calculateGiftCodeDiscountForSubmit,
  calculatePromoDiscount,
} from "../../_helpers/fareUtils";
import { getLocalItem } from "../../_helpers/storageUtils";
import { getTotalSSRCount } from "../../_helpers/ssrUtils";
import { formatTraveller } from "../../_helpers/bookingUtils";
import { getSelectedItems } from "../../_helpers/miscUtils";
import {
  formatIndianNumber,
  generateNewPayloadFromUrl,
  maskName,
} from "../../_helpers/formatUtils";
import { useValidationSchema } from "./hooks/useValidationSchema";
import { useFormSubmit } from "./hooks/useFormSubmit";
import { getWalletBalance } from "../wallet/services/wallet.services";
import { API_URL } from "../../app/config";
import { getAllEtraveFlights } from "../flights/services/flight.services";

const ReviewBookingNew = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const billingData = useAppSelector((state) => state.profile.billingData);
  const dispatch = useAppDispatch();
  const [isSessionExpired, setIsSessionExpired] = useState(false);
  const [sessionReady, setSessionReady] = useState(false);
  const [travellerConfirm, setTravellerConfirm] = useState(false);
  // const [processContinue, setProcessContinue] = useState(false);
  const [appliedPromo, setAppliedPromo] = useState<any>(null);
  const [appliedPromoAmount, setAppliedPromoAmount] = useState<number>(0);
  const [useWallet, setUseWallet] = useState(false);
  const [walletAmount, setWalletAmount] = useState(0);
  const [totalSeats, setTotalSeats] = useState<any[]>([]);
  const [selectedmealPerSegment, setSelectedMealPerSegment] = useState<{
    [index: number]: any[];
  }>({});
  const [selectedBaggagePerSegment, setSelectedBaggagePerSegment] = useState<{
    [index: number]: any[];
  }>({});
  const [selectedWheelChairPerSegment, setSelectedWheelChairPerSegment] =
    useState<{
      [index: number]: any[];
    }>({});
  const [otherServices, setOtherServices] = useState<
    { label: string; amount: number }[]
  >([]);
  const [totalSeatsAmount, setTotalSeatsAmount] = useState(0);
  const [totalMealAmount, setTotalMealAmount] = useState(0);
  const [totalBaggageAmount, setTotalBaggageAmount] = useState(0);
  const [totalWheelChairAmount, setTotalWheelChairAmount] = useState(0);
  const [isAlertAvailabel, setIsAlertAvaialbel] = useState(false);
  // const [firstRender, setFirstRender] = useState(true);
  const [maskedName, setMaskedName] = useState(
    maskName(billingData?.billing_pan_card_name || "")
  );
  const [panStatus, setPanStatus] = useState<
    "idle" | "valid" | "invalid" | "loading"
  >("idle");

  const [lastVerifiedPan, setLastVerifiedPan] = useState<string | null>(null);

  // Add at the top with other useState declarations
  const [tempBookingRef, setTempBookingRef] = useState<string | null>(
    sessionStorage.getItem("temp_booking_ref")
  );
  const [portalBookingNo, setPortalBookingNo] = useState<string | null>(
    sessionStorage.getItem("portal_booking_no")
  );
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);

  const [pendingGiftCode, setPendingGiftCode] = useState<any>(null);

  const [appliedGiftCode, setAppliedGiftCode] = useState<any>(null);
  const [appliedGiftCodeAmount, setAppliedGiftCodeAmount] = useState<number>(0);
  const [showOtpModal, setShowOtpModal] = useState(false);

  console.log("appliedGiftCode", appliedGiftCode);
  console.log("appliedGiftCodeAmount", appliedGiftCodeAmount);

  const [useCreditLimit, setUseCreditLimit] = useState(false);
  const [creditLimitAmount, setCreditLimitAmount] = useState(0);

  const reviewBookingDetails = useAppSelector(
    (state) => state.reviewbooking.reviewBookingDetails
  );
  const flightReviewDetails = useAppSelector(
    (state) => state.reviewbooking.flightReviewDetails
  );
  const loading = useAppSelector((state) => state.reviewbooking.loading);
  const bookingLoading = useAppSelector(
    (state) => state.reviewbooking.bookingLoading
  );
  const paymentLoading = useAppSelector(
    (state) => state.reviewbooking.paymentLoading
  );
  const travellerLoading = useAppSelector(
    (state) => state.reviewbooking.travellerLoading
  );
  const rePrintLoading = useAppSelector((state) => state.mytrips.loading);

  const flightLoading = useAppSelector((state) => state.flight.loading);

  const handlingFees = useAppSelector(
    (state) => state.reviewbooking.handlingFees
  );

  const adminCharges = useAppSelector(
    (state) => state.reviewbooking.adminCharges
  );

  const walletDetails = useAppSelector((state) => state.wallet.walletDetails);

  const initialValues: IReviewBookingDetails = reviewBookingDetails;

  const reviewsummaryBtnRef = useRef<HTMLButtonElement>(null);
  const fieldRefs = useRef<any>({});

  const AdultRequireDetails =
    flightReviewDetails &&
    flightReviewDetails[0]?.Required_PAX_Details &&
    flightReviewDetails[0]?.Required_PAX_Details.find(
      (e: any) => e.Pax_type === 0
    );

  const ChildRequireDetails =
    flightReviewDetails &&
    flightReviewDetails[0]?.Required_PAX_Details &&
    flightReviewDetails[0]?.Required_PAX_Details.find(
      (e: any) => e.Pax_type === 1
    );

  const InfantRequireDetails =
    flightReviewDetails &&
    flightReviewDetails[0]?.Required_PAX_Details &&
    flightReviewDetails[0]?.Required_PAX_Details.find(
      (e: any) => e.Pax_type === 2
    );

  const isGSTApplicable = flightReviewDetails?.some(
    (item: any) => item?.Flight?.GST_Entry_Allowed
  );

  const isGSTRequired = flightReviewDetails?.some((item: any) =>
    item?.Flight?.Fares?.some((fare: any) => fare?.GSTMandatory)
  );

  const ADULT = location.state?.ADULT || 0;
  const CHILD = location.state?.CHILD || 0;
  const INFANT = location.state?.INFANT || 0;

  const isInternational = isInternationalFlight(
    flightReviewDetails?.flatMap((item: any) => item.Flight?.Segments || []) ||
      []
  );

  const baseConvenienceFee = isInternational
    ? adminCharges?.InternationalFlightCharge || 0
    : adminCharges?.DomesticFlightCharge || 0;

  const gstAmount = (baseConvenienceFee * handlingFees?.GSTPer) / 100;
  const convenienceFeeWithGST =
    (baseConvenienceFee + gstAmount) * (ADULT + CHILD);

  const fareDetails = calculateFareDetails(
    flightReviewDetails || [],
    location.state
  );

  const totalAmount =
    fareDetails?.overall?.basic +
    fareDetails?.overall?.taxes +
    // fareDetails?.overall?.serviceAmount +
    totalSeatsAmount +
    totalMealAmount +
    totalBaggageAmount +
    totalWheelChairAmount +
    convenienceFeeWithGST -
    appliedPromoAmount -
    appliedGiftCodeAmount -
    walletAmount -
    creditLimitAmount;

  const { validationSchema } = useValidationSchema({
    ADULT,
    CHILD,
    INFANT,
    AdultRequireDetails,
    ChildRequireDetails,
    InfantRequireDetails,
    isGSTRequired,
    totalAmount,
    billingData,
    travellerConfirm,
  });

  const formik = useFormik<IReviewBookingDetails>({
    initialValues,
    validationSchema,
    onSubmit: (values) => handleSubmit(values),
    enableReinitialize: true,
  });

  useEffect(() => {
    const latestStoredfare = sessionStorage.getItem("latestfarePrice") || "";
    const totalFare = fareDetails?.overall.total;

    if (
      +latestStoredfare > 0 &&
      totalFare > 0 &&
      +latestStoredfare !== totalFare
    ) {
      setIsAlertAvaialbel(true);
    } else {
      setIsAlertAvaialbel(false);
    }
  }, [sessionStorage.getItem("latestfarePrice"), fareDetails?.overall.total]);

  useEffect(() => {
    const totalSeatsAmount = totalSeats.reduce((acc: number, seat: any) => {
      return acc + (seat?.Total_Amount || 0);
    }, 0);

    const totalMealAmount = Object.values(selectedmealPerSegment || {})
      .flatMap((segmentSSR: any) => Object.values(segmentSSR || {}))
      .flat()
      .reduce(
        (acc: number, ssr: any) => acc + (parseFloat(ssr?.Total_Amount) || 0),
        0
      );

    const totalBaggageAmount = Object.values(selectedBaggagePerSegment || {})
      .flatMap((segmentSSR: any) => Object.values(segmentSSR || {}))
      .flat()
      .reduce(
        (acc: number, ssr: any) => acc + (parseFloat(ssr?.Total_Amount) || 0),
        0
      );

    const totalWheelchairAmount = Object.values(
      selectedWheelChairPerSegment || {}
    )
      .flatMap((segmentSSR: any) => Object.values(segmentSSR || {}))
      .flat()
      .reduce(
        (acc: number, ssr: any) => acc + (parseFloat(ssr?.Total_Amount) || 0),
        0
      );

    const mealCount = getTotalSSRCount(selectedmealPerSegment);
    const baggageCount = getTotalSSRCount(selectedBaggagePerSegment);
    const wheelchairCount = getTotalSSRCount(selectedWheelChairPerSegment);

    setTotalSeatsAmount(totalSeatsAmount);
    setTotalMealAmount(totalMealAmount);
    setTotalBaggageAmount(totalBaggageAmount);
    setTotalWheelChairAmount(totalWheelchairAmount);

    const services = [];

    if (mealCount > 0) {
      services.push({ label: "Meals", amount: totalMealAmount });
    }

    if (baggageCount > 0) {
      services.push({ label: "Baggage", amount: totalBaggageAmount });
    }

    if (totalSeats.length > 0) {
      services.push({ label: "Seats", amount: totalSeatsAmount });
    }

    if (wheelchairCount > 0) {
      services.push({ label: "Wheel Chair", amount: totalWheelchairAmount });
    }

    setOtherServices(services);

    const totalAmount =
      fareDetails?.overall?.basic +
      fareDetails?.overall?.taxes +
      // fareDetails?.overall?.serviceAmount +
      totalSeatsAmount +
      totalMealAmount +
      totalBaggageAmount +
      totalWheelChairAmount +
      convenienceFeeWithGST;

    if (appliedPromo) {
      const promoAmount = calculatePromoDiscount(appliedPromo, totalAmount);
      setAppliedPromoAmount(promoAmount);
    }

    if (appliedGiftCode) {
      const giftcodeAmount = calculateGiftCodeDiscount(
        appliedGiftCode?.MaxAmtUsage,
        totalAmount
      );
      setAppliedGiftCodeAmount(giftcodeAmount);
    }
  }, [
    totalSeats,
    selectedmealPerSegment,
    selectedBaggagePerSegment,
    selectedWheelChairPerSegment,
  ]);

  useEffect(() => {
    dispatch(
      getGroupwiseTravellerByUserID({ user_guid: getLocalItem("user_guid") })
    );
    dispatch(getAllActiveCountries());
    dispatch(getHandlingFees());
    dispatch(getChargesByMembershipPlan(getLocalItem("user_guid") || ""));
    dispatch(getWalletBalance());

    return () => {
      sessionStorage.removeItem("temp_booking_ref");
      sessionStorage.removeItem("portal_booking_no");
    };
  }, []);

  useEffect(() => {
    if (totalAmount >= MAX_PAN_REQUIRED_AMOUNT) {
      dispatch(getBillingDetails({ user_guid: getLocalItem("user_guid") }));
    }
  }, [totalAmount]);

  const handlePromoCodeApply = async () => {
    if (formik.values?.PromoCode) {
      const res = await dispatch(
        getPromoCodeDetails(formik.values?.PromoCode?.trim())
      );
      if (
        res.payload?.ApplyOn === "ALL FLIGHTS" ||
        (res.payload?.ApplyOn === "INTERNATIONAL FLIGHTS" && isInternational) ||
        (res.payload?.ApplyOn === "DOMESTIC FLIGHTS" && !isInternational)
      ) {
        setAppliedPromo(res.payload);

        const totalOtherFee = otherServices?.reduce((acc: number, fee: any) => {
          return (acc = acc + (fee?.amount || 0));
        }, 0);

        const totalAmount =
          fareDetails?.overall?.basic +
          fareDetails?.overall?.taxes +
          // fareDetails?.overall?.serviceAmount +
          totalOtherFee +
          convenienceFeeWithGST;

        const promoAmount = calculatePromoDiscount(res.payload, totalAmount);

        setAppliedPromoAmount(promoAmount);
      } else {
        setAppliedPromo(null);
        setAppliedPromoAmount(0);
      }
    }
  };

  const handlePromoCodeRemove = () => {
    setAppliedPromo(null);
    setAppliedPromoAmount(0);
    formik.setFieldValue("PromoCode", "");
  };

  const handleGiftCodeApply = async () => {
    const giftCode = formik.values?.GiftCode?.trim();
    if (!giftCode) return;

    const totalOtherFee = otherServices?.reduce((acc: number, fee: any) => {
      return (acc = acc + (fee?.amount || 0));
    }, 0);

    const totalAmount =
      fareDetails?.overall?.basic +
      fareDetails?.overall?.taxes +
      // fareDetails?.overall?.serviceAmount +
      totalOtherFee +
      convenienceFeeWithGST;

    const res = await dispatch(
      reedemGiftCodeForBooking({
        GiftCode: giftCode,
        BookingAmount: totalAmount,
      })
    ); // here need to change payload
    if (res?.meta.requestStatus === "fulfilled") {
      setShowOtpModal(true);
      setPendingGiftCode(res.payload);
      // setAppliedGiftCode(res.payload?.GiftCode);
      SuccessToast("OTP sent to your registered mobile number.");
    } else {
      setPendingGiftCode(null);
      setAppliedGiftCode(null);
      setAppliedGiftCodeAmount(0);
      setShowOtpModal(false);
    }
  };

  const handleGiftCodeOtpVerify = async () => {
    const giftCode = formik.values?.GiftCode?.trim();
    const otpValue = formik.values?.GiftCodeOtp?.trim();

    if (!otpValue) {
      ErrorToast("Please enter OTP to verify gift code.");
      return;
    }

    const res = await dispatch(
      verifyGiftCodeOtp({
        GiftCode: giftCode,
        OTP: otpValue,
      })
    );

    if (res?.meta.requestStatus === "fulfilled") {
      setAppliedGiftCode(pendingGiftCode);
       const giftcodeAmount = calculateGiftCodeDiscount(
        pendingGiftCode?.MaxAmtUsage,
        totalAmount
      );
      setAppliedGiftCodeAmount(giftcodeAmount);
      setShowOtpModal(false);

      setPendingGiftCode(null);

      SuccessToast("Gift code verified & applid successfully.");

      formik.setFieldValue("GiftCodeOtp", "");
    }
  };

  const handleGiftCodeRemove = () => {
    formik.setFieldValue("GiftCode", "");
    formik.setFieldValue("GiftOtp", "");
    setAppliedGiftCode(null);
    setAppliedGiftCodeAmount(0);
    setShowOtpModal(false);
    setPendingGiftCode(null);

    SuccessToast("Gift code removed successfully.");
  };

  const availableCreditLimit = walletDetails?.OutStandingAmount || 0;

  const creditLimitSummary = {
    usedFromCreditLimit: Math.min(
      creditLimitAmount,
      availableCreditLimit,
      totalAmount + creditLimitAmount // Prevent exceeding remaining amount
    ),
  };

  // const clearGiftCodeAfterBooking = () => {
  //   setAppliedGiftCodeAmount(0);
  //   setAppliedGiftCode(null);
  //   setShowOtpModal(false);
  //   formik.setFieldValue("GiftCode", "");
  //   formik.setFieldValue("GiftCodeOtp", "");
  // };

  const fetchPanDetails = debounce(async (pan: string) => {
    setPanStatus("loading");
    try {
      const res = await axios.post(`${API_URL}/pan-verification`, {
        PanNumber: pan,
      });

      if (res.status === 200 && res.data.status === 0 && res.data?.data) {
        const name = `${res.data?.data?.first_name} ${res.data?.data?.middle_name} ${res.data?.data?.last_name}`;
        setMaskedName(maskName(name || ""));
        setPanStatus("valid");
        setLastVerifiedPan(pan);
        formik.setFieldValue("billing_pan_card_name", name);
      } else {
        setPanStatus("invalid");
        setLastVerifiedPan(null);
        formik.setFieldValue("billing_pan_card_name", "");
      }
    } catch (err) {
      setPanStatus("invalid");
      setLastVerifiedPan(null);
      formik.setFieldValue("billing_pan_card_name", "");
    }
  }, 500);

  useEffect(() => {
    const pan = formik.values.billing_pan_card_no?.toUpperCase() || "";

    if (/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan)) {
      const shouldVerify =
        pan !== lastVerifiedPan && pan !== billingData?.billing_pan_card_no;

      if (shouldVerify) {
        fetchPanDetails(pan);
      } else if (
        billingData?.billing_pan_card_no &&
        billingData?.billing_pan_card_name
      ) {
        setPanStatus("valid");
        setMaskedName(maskName(billingData?.billing_pan_card_name || ""));
        formik.setFieldValue(
          "billing_pan_card_name",
          billingData?.billing_pan_card_name
        );
      } else if (pan === lastVerifiedPan && maskedName) {
        setPanStatus("valid");
      }
    } else {
      setPanStatus("idle");
    }
  }, [formik.values.billing_pan_card_no]);

  const travellers = [
    ...formik.values?.adults.filter((e: any) => e.isSelected && ADULT > 0),
    ...formik.values?.children.filter((e: any) => e.isSelected && CHILD > 0),
  ];
  const alltravellers = [
    ...formik.values?.adults.filter((e: any) => e.isSelected && ADULT > 0),
    ...formik.values?.children.filter((e: any) => e.isSelected && CHILD > 0),
    ...formik.values?.infants.filter((e: any) => e.isSelected && INFANT > 0),
  ];

  const travellerInfo = [
    ...formik.values?.adults
      .filter((e: any) => e.isSelected && ADULT > 0)
      .map((adult: any) => formatTraveller(adult, "0", AdultRequireDetails)),
    ...formik.values?.children
      .filter((e: any) => e.isSelected && CHILD > 0)
      .map((child: any) => formatTraveller(child, "1", ChildRequireDetails)),
    ...formik.values?.infants
      .filter((e: any) => e.isSelected && INFANT > 0)
      .map((infant: any) => formatTraveller(infant, "2", InfantRequireDetails)),
  ];

  const updatedTravellerInfo = travellerInfo.map(
    (traveller: any, index: number) => ({
      ...traveller,
      Pax_Id: index + 1,
    })
  );

  const Search_Key = location.state?.Search_Key || "";
  const AirRepriceRequests = location.state?.AirRepriceRequests || [];

  const Flight_Keys = flightReviewDetails?.map(
    (e: any) => e?.Flight?.Flight_Key
  );

  const isAddonShow = travellerInfo?.length === ADULT + CHILD + INFANT;

  useEffect(() => {
    dispatch(
      getAirlineReprice({
        AirRepriceRequests: AirRepriceRequests,
        Search_Key: Search_Key || "",
        Customer_Mobile: AGENCY_NUMBER,
        GST_Input: false,
        SinglePricing: true,
      })
    ).then((res) => {
      setSessionReady(true);
      if (
        (Object.keys(
          Object.values(selectedBaggagePerSegment).some(
            (ssrItems: any) => Object.values(ssrItems).length <= 0
          )
        ) ||
          Object.keys(
            Object.values(selectedmealPerSegment).some(
              (ssrItems: any) => Object.values(ssrItems).length <= 0
            )
          ) ||
          Object.keys(
            Object.values(selectedWheelChairPerSegment).some(
              (ssrItems: any) => Object.values(ssrItems).length <= 0
            )
          )) &&
        res?.payload?.AirRepriceResponses?.length > 0
      ) {
        dispatch(
          getSSRList({
            AirSSRRequestDetails: res?.payload?.AirRepriceResponses?.map(
              (e: any) => ({
                Flight_Key: e?.Flight?.Flight_Key,
              })
            ),
            Search_Key: Search_Key || "",
          })
        );
      }
    });
  }, [location.state, dispatch]);

  useEffect(() => {
    if (isAddonShow && totalSeats?.length <= 0) {
      setTravellerConfirm(true);
      dispatch(
        getSeatMap({
          Flight_Keys: Flight_Keys,
          Search_Key: Search_Key || "",
          PAX_Details: updatedTravellerInfo,
        })
      );
    }
  }, [travellerInfo?.length]);

  useEffect(() => {
    const sessionCreatedTime = sessionStorage.getItem("sessionCreatedTime");
    const sessionDurationInSeconds = sessionStorage.getItem(
      "sessionDurationInSeconds"
    );

    if (sessionCreatedTime && sessionDurationInSeconds) {
      const sessionStartTime = moment(sessionCreatedTime);
      const sessionExpirationTime = sessionStartTime.add(
        parseInt(sessionDurationInSeconds, 10),
        "seconds"
      );

      const checkSessionExpiration = () => {
        const currentTime = moment();
        if (currentTime.isAfter(sessionExpirationTime)) {
          setIsSessionExpired(true);
        }
      };

      checkSessionExpiration();

      const interval = setInterval(checkSessionExpiration, 1000);

      return () => clearInterval(interval);
    }
  }, [sessionReady]);

  // const handleValidationComplete = (errors: any) => {
  //   const findFirstErrorField = (obj: any, path = ""): string | null => {
  //     if (typeof obj === "object" && obj !== null) {
  //       for (const key in obj) {
  //         const newPath = path ? `${path}.${key}` : key;
  //         const result = findFirstErrorField(obj[key], newPath);
  //         if (result) return result;
  //       }
  //     } else if (obj) {
  //       return path;
  //     }
  //     return null;
  //   };

  //   const firstErrorFieldPath = findFirstErrorField(errors);

  //   if (firstErrorFieldPath) {
  //     const refKey = firstErrorFieldPath.replace(/\.(\d+)/g, "[$1]");
  //     const fieldRef = fieldRefs.current[refKey];

  //     if (fieldRef && fieldRef.focus) {
  //       if (firstRender) {
  //         setFirstRender(false);
  //       }
  //       fieldRef.focus();
  //       return false;
  //     } else {
  //       console.log(`No ref found for ${firstErrorFieldPath}`);
  //     }
  //   }

  //   return true;
  // };

  const toggleTotalSeatSelection = (seat: any, index: number) => {
    const routewiseSegmentArray = flightReviewDetails.flatMap(
      (e: any) => e.Flight?.Segments
    );

    setTotalSeats((prevSelected: any[]) => {
      const updatedSeat = {
        ...seat,
        segmentindex: index,
        segmentPlace:
          routewiseSegmentArray[index]?.Origin_City +
          "-" +
          routewiseSegmentArray[index]?.Destination_City,
      };

      // Count how many seats are selected for the current segment
      const currentSegmentSeats = prevSelected.filter(
        (s) => s.segmentindex === index
      );

      // Check if seat already selected (toggle off)
      if (prevSelected.some((s) => s.SSR_Key === seat.SSR_Key)) {
        return prevSelected.filter((s) => s.SSR_Key !== seat.SSR_Key);
      }

      // Prevent selecting more than allowed for this segment
      if (currentSegmentSeats.length >= travellers.length) {
        ErrorToast(
          `You have already selected ${travellers.length} seats for this segment. Remove before adding a new one.`
        );
        return prevSelected;
      }

      return [...prevSelected, updatedSeat];
    });
  };

  const toggleMealSelection = (
    ssr: any,
    passengerIndex: number,
    segmentIndex: number
  ) => {
    setSelectedMealPerSegment((prev) => {
      const passengerSSRMap = { ...(prev[passengerIndex] || {}) };

      // Toggle: deselect if already selected, else select
      if (
        passengerSSRMap[segmentIndex] &&
        passengerSSRMap[segmentIndex].SSR_Key === ssr.SSR_Key
      ) {
        delete passengerSSRMap[segmentIndex];
      } else {
        passengerSSRMap[segmentIndex] = ssr;
      }

      return {
        ...prev,
        [passengerIndex]: passengerSSRMap,
      };
    });
  };

  const toggleBaggageSelection = (
    ssr: any,
    passengerIndex: number,
    segmentIndex: number
  ) => {
    setSelectedBaggagePerSegment((prev) => {
      const passengerSSRMap = { ...(prev[passengerIndex] || {}) };

      // Toggle: deselect if already selected, else select
      if (
        passengerSSRMap[segmentIndex] &&
        passengerSSRMap[segmentIndex].SSR_Key === ssr.SSR_Key
      ) {
        delete passengerSSRMap[segmentIndex]; // Deselect
      } else {
        passengerSSRMap[segmentIndex] = ssr; // Select
      }

      return {
        ...prev,
        [passengerIndex]: passengerSSRMap,
      };
    });
  };

  const toggleWheelChairSelection = (
    ssr: any,
    passengerIndex: number,
    segmentIndex: number
  ) => {
    setSelectedWheelChairPerSegment((prev) => {
      const passengerSSRMap = { ...(prev[passengerIndex] || {}) };

      // Toggle: deselect if already selected, else select
      if (
        passengerSSRMap[segmentIndex] &&
        passengerSSRMap[segmentIndex].SSR_Key === ssr.SSR_Key
      ) {
        delete passengerSSRMap[segmentIndex]; // Deselect
      } else {
        passengerSSRMap[segmentIndex] = ssr; // Select
      }

      return {
        ...prev,
        [passengerIndex]: passengerSSRMap,
      };
    });
  };

  function useWalletAmount(walletAmount: number) {
    let remainingAmount = walletAmount;
    let usedRefundable = 0;
    let usedNonRefundable = 0;

    // First try to use refundable amount
    if (remainingAmount > 0 && walletDetails.refundable_walletamount > 0) {
      usedRefundable = Math.min(
        remainingAmount,
        walletDetails.refundable_walletamount
      );
      remainingAmount -= usedRefundable;
    }

    // If still need more, use non-refundable amount
    if (remainingAmount > 0 && walletDetails.non_refundable_walletamount > 0) {
      usedNonRefundable = Math.min(
        remainingAmount,
        walletDetails.non_refundable_walletamount
      );
      remainingAmount -= usedNonRefundable;
    }

    return {
      usedFromWallet: usedRefundable + usedNonRefundable,
      usedRefundable,
      usedNonRefundable,
    };
  }

  const walletAmountSummary = useWalletAmount(walletAmount);

  const totalAmountForGiftCodeCalculation =
    fareDetails?.overall?.basic +
    fareDetails?.overall?.taxes +
    // fareDetails?.overall?.serviceAmount +
    totalSeatsAmount +
    totalMealAmount +
    totalBaggageAmount +
    totalWheelChairAmount +
    convenienceFeeWithGST;

  const { handleSubmit } = useFormSubmit({
    formik,
    flightReviewDetails,
    location,
    navigate,
    dispatch,
    totalAmount,
    totalSeatsAmount,
    totalBaggageAmount,
    totalWheelChairAmount,
    totalMealAmount,
    MAX_PAN_REQUIRED_AMOUNT,
    billingData,
    totalSeats,
    selectedmealPerSegment,
    selectedBaggagePerSegment,
    selectedWheelChairPerSegment,
    convenienceFeeWithGST,
    handlingFees,
    appliedPromo,
    appliedGiftCode: appliedGiftCode?.GiftCode,
    appliedPromoAmount,
    appliedGiftCodeAmount: appliedGiftCode?.GiftCode
      ? calculateGiftCodeDiscountForSubmit(
          appliedGiftCode?.MinAmtUsage,
          appliedGiftCode?.MaxAmtUsage,
          totalAmountForGiftCodeCalculation
        )
      : 0,
    walletAmount: walletAmountSummary.usedFromWallet,
    walletRefundableAmount: walletAmountSummary.usedRefundable,
    walletNonRefundableAmount: walletAmountSummary.usedNonRefundable,
    fieldRefs,
    creditLimitAmount: creditLimitSummary.usedFromCreditLimit,
    ADULT,
    CHILD,
    INFANT,
    AdultRequireDetails,
    ChildRequireDetails,
    InfantRequireDetails,
    // new added for preserv data
    tempBookingRef,
    setTempBookingRef,
    portalBookingNo,
    setPortalBookingNo,
    setIsProcessingPayment,
    isProcessingPayment,
  });

  const handleCheckboxChange = (
    type: "adults" | "children" | "infants",
    flightDetailsKey: "ADULT" | "CHILD" | "INFANT",
    index: number,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedItems = getSelectedItems(formik.values[type])?.length;
    const maxItems = location.state[flightDetailsKey];

    if (e.target.checked && selectedItems >= maxItems) {
      formik.setFieldError(
        `${type}Limit`,
        `You have already selected ${location.state[flightDetailsKey]} ${flightDetailsKey}. Remove before adding a new one.`
      );
    } else {
      formik.handleChange(e);
    }
  };

  const handleSearchAgain = async () => {
    const flightDetails = JSON.parse(
      localStorage.getItem("flightDetails") || "{}"
    );

    const lastSearchQueryParams = `?${
      flightDetails?.lastFlightSearchUrl?.split("?")[1]
    }`;

    const flightSearchPayloadNew = generateNewPayloadFromUrl(
      lastSearchQueryParams
    );

    await dispatch(
      getAllEtraveFlights({ ...flightSearchPayloadNew, IsHotRefresh: true })
    );

    const session_id = sessionStorage.getItem("session_id");
    sessionStorage.clear();
    sessionStorage.setItem("session_id", session_id || "");
    window.location.assign(
      `${flightDetails?.lastFlightSearchUrl || window.location.origin}`
    );
  };

  const handleHotRefresh = () => {
    const flightDetails = JSON.parse(
      localStorage.getItem("flightDetails") || "{}"
    );

    const lastSearchQueryParams = `?${
      flightDetails?.lastFlightSearchUrl?.split("?")[1]
    }`;

    const flightSearchPayloadNew = generateNewPayloadFromUrl(
      lastSearchQueryParams
    );
    dispatch(
      getAllEtraveFlights({ ...flightSearchPayloadNew, IsHotRefresh: true })
    );

    setIsAlertAvaialbel(false);
  };

  return (
    <>
      <Loading
        loading={
          travellerLoading ||
          loading ||
          bookingLoading ||
          paymentLoading ||
          rePrintLoading
        }
        backgroundColor="white"
      />
      {!(
        travellerLoading ||
        loading ||
        bookingLoading ||
        paymentLoading ||
        rePrintLoading
      ) && (
        <div className="Booking-page">
          <div className="container">
            <>
              {flightReviewDetails?.length > 0 ? (
                <FormikProvider value={formik}>
                  <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                      <div className="col-lg-8 col-md-7 col-sm-12">
                        <div className="booking-page-right">
                          <h2>Complete your booking</h2>
                          {/* {!travellerConfirm ? ( */}
                          <>
                            {flightReviewDetails?.length > 0 &&
                              flightReviewDetails?.map(
                                (route: any, index: number) => {
                                  return (
                                    <ReviewFlightRouteCard
                                      route={route}
                                      key={index}
                                      index={index}
                                    />
                                  );
                                }
                              )}
                            <IMPInfoCard />
                            <div className="traveller-detail">
                              <h4>Traveller Details</h4>
                              {ADULT > 0 && (
                                <AdultForm
                                  formik={formik}
                                  handleCheckboxChange={handleCheckboxChange}
                                  AdultRequireDetails={AdultRequireDetails}
                                  ADULT={ADULT}
                                  fieldRefs={fieldRefs}
                                />
                              )}
                              {CHILD > 0 && (
                                <ChildForm
                                  formik={formik}
                                  handleCheckboxChange={handleCheckboxChange}
                                  ChildRequireDetails={ChildRequireDetails}
                                  CHILD={CHILD}
                                  fieldRefs={fieldRefs}
                                />
                              )}
                              {INFANT > 0 && (
                                <InfantForm
                                  formik={formik}
                                  handleCheckboxChange={handleCheckboxChange}
                                  InfantRequireDetails={InfantRequireDetails}
                                  INFANT={INFANT}
                                  fieldRefs={fieldRefs}
                                />
                              )}
                              <ContactDetailsForm
                                formik={formik}
                                isGSTRequired={isGSTRequired}
                                isGSTApplicable={isGSTApplicable}
                                fieldRefs={fieldRefs}
                              />
                            </div>
                            <AddOnsCard
                              travellers={travellers}
                              alltravellers={alltravellers}
                              isAddonShow={isAddonShow}
                              totalBaggageAmount={totalBaggageAmount}
                              totalWheelChairAmount={totalWheelChairAmount}
                              totalMealAmount={totalMealAmount}
                              totalSeatsAmount={totalSeatsAmount}
                              // setTravellerConfirm={setTravellerConfirm}
                              // setProcessContinue={setProcessContinue}
                              toggleTotalSeatSelection={
                                toggleTotalSeatSelection
                              }
                              toggleMealSelection={toggleMealSelection}
                              selectedmealPerSegment={selectedmealPerSegment}
                              toggleBaggageSelection={toggleBaggageSelection}
                              selectedBaggagePerSegment={
                                selectedBaggagePerSegment
                              }
                              toggleWheelChairSelection={
                                toggleWheelChairSelection
                              }
                              selectedWheelChairPerSegment={
                                selectedWheelChairPerSegment
                              }
                              totalSeats={totalSeats}
                            />
                            {totalAmount >= MAX_PAN_REQUIRED_AMOUNT &&
                              !billingData?.billing_pan_card_no && (
                                <PanInfoCard
                                  formik={formik}
                                  fieldRefs={fieldRefs}
                                  maskedName={maskedName}
                                  panStatus={panStatus}
                                  setPanStatus={setPanStatus}
                                  lastVerifiedPan={lastVerifiedPan}
                                />
                              )}
                            <span className="agree-note">
                              By clicking on the Continue button below to
                              proceed with the booking, <br />I confirm that I
                              have read and I accept the&nbsp;Fare Rules,
                              the&nbsp;
                              <a href="#">Privacy Policy</a>&nbsp;, the&nbsp;
                              <a href="#">
                                User Agreement&nbsp;and&nbsp;Terms of Service
                              </a>
                            </span>
                            <div className="traveller-detail travrller-btn pay-btns">
                              <a
                                className="fill-btn"
                                href="javascript:void(0)"
                                onClick={async () => {
                                  const userGuid =
                                    localStorage.getItem("user_guid");
                                  // const isEmailVerified =
                                  //   localStorage.getItem("is_email_verified");

                                  if (!userGuid) {
                                    return ErrorToast(
                                      "Please login to book a flight!!!"
                                    );
                                  }

                                  if (isProcessingPayment) return;

                                  // let verified = isEmailVerified === "true";

                                  // if (!verified) {
                                  //   const res = await dispatch(
                                  //     getLoginDetailsByID({
                                  //       user_guid: userGuid,
                                  //     })
                                  //   );
                                  //   verified =
                                  //     res?.payload?.is_email_verified === true;
                                  // }

                                  // if (!verified) {
                                  //   return ErrorToast(
                                  //     "Please verify your email from profile to book a flight!!!"
                                  //   );
                                  // }

                                  // if (handleValidationComplete(formik.errors)) {
                                  formik.handleSubmit();
                                  // if (travellerConfirm && !processContinue) {
                                  //   ErrorToast("Seat selection remaining");
                                  // }
                                  // }
                                }}
                              >
                                {/* {travellerConfirm
                                  ? "Proceed to Pay"
                                  : "Continue"} */}
                                {"Proceed to Pay"}
                              </a>
                            </div>
                          </>

                          <button
                            data-bs-toggle="modal"
                            data-bs-target="#reviewsummary"
                            ref={reviewsummaryBtnRef}
                            type="button"
                            style={{ display: "none" }}
                          />
                          <ReviewBookingSummary
                            formik={formik}
                            // setTravellerConfirm={setTravellerConfirm}
                            INFANT={INFANT}
                            CHILD={CHILD}
                            ADULT={ADULT}
                          />
                        </div>
                      </div>
                      <ReviewPriceCard
                        flightReviewDetails={flightReviewDetails}
                        // handleSubmit={() => formik.handleSubmit()}
                        otherServices={otherServices}
                        appliedPromo={appliedPromo}
                        walletAmount={walletAmount}
                        useWallet={useWallet}
                        setWalletAmount={setWalletAmount}
                        setUseWallet={setUseWallet}
                        creditLimitAmount={creditLimitAmount}
                        useCreditLimit={useCreditLimit}
                        setCreditLimitAmount={setCreditLimitAmount}
                        setUseCreditLimit={setUseCreditLimit}
                        availableCreditLimit={availableCreditLimit}
                        appliedPromoAmount={appliedPromoAmount}
                        handlePromoCodeApply={handlePromoCodeApply}
                        handlePromoCodeRemove={handlePromoCodeRemove}
                        handleGiftCodeApply={handleGiftCodeApply}
                        handleGiftCodeRemove={handleGiftCodeRemove}
                        showOtpModal={showOtpModal}
                        setShowOtpModal={setShowOtpModal}
                        handleGiftCodeOtpVerify={handleGiftCodeOtpVerify}
                        appliedGiftCode={appliedGiftCode}
                        appliedGiftCodeAmount={appliedGiftCodeAmount}
                        convenienceFeeWithGST={convenienceFeeWithGST}
                        // handleValidationComplete={(errors) =>
                        //   handleValidationComplete(errors)
                        // }
                        formik={formik}
                        isProcessingPayment={isProcessingPayment}
                        // errors={formik.errors}
                        btnText={"Proceed to Pay"}
                        // btnText={
                        //   travellerConfirm ? "Proceed to Pay" : "Continue"
                        // }
                        // isNotContinue={travellerConfirm && !processContinue}
                      />
                    </div>
                  </form>
                </FormikProvider>
              ) : (
                <div className="reviewbooking-something-wrong">
                  <h1>Something went Wrong!</h1>
                  <button
                    className="fill-btn fw-600"
                    onClick={() => handleSearchAgain()}
                  >
                    Search Again
                  </button>
                </div>
              )}
            </>
          </div>
          {isAlertAvailabel && !isSessionExpired && (
            <>
              <span className="overlay" style={{ display: "block" }}></span>
              <div
                className="modal fade show"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex={-1}
                aria-labelledby="session-expired"
                aria-modal="true"
                style={{ display: "block" }}
                role="dialog"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  style={{ maxWidth: 400 }}
                >
                  <div className="modal-content position-relative overflow-hidden">
                    <Loading loading={flightLoading} />
                    <div className="modal-header justify-content-center">
                      <h4 className="modal-title fs-5" id="session-expired">
                        Fare Price Updated!
                      </h4>
                    </div>
                    <div className="modal-body text-center">
                      <span className="fareupdate-text">
                        The fare for your flight has been changed from{" "}
                        <b>
                          ₹{" "}
                          {formatIndianNumber(
                            +(sessionStorage.getItem("latestfarePrice") || "0")
                          )}
                        </b>{" "}
                        to{" "}
                        <b>
                          ₹ {formatIndianNumber(fareDetails?.overall?.total)}
                        </b>
                        . Do you want to continue?
                      </span>
                      <div className="fareupdate-btn-list">
                        <button
                          className="fill-btn fill-btn-disabled fw-600"
                          onClick={() => handleSearchAgain()}
                        >
                          Back to Flight List
                        </button>
                        <button
                          className="fill-btn fw-600"
                          onClick={() => handleHotRefresh()}
                        >
                          Continue
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          {isSessionExpired && (
            <>
              <span className="overlay" style={{ display: "block" }}></span>
              <div
                className="modal fade show"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex={-1}
                aria-labelledby="session-expired"
                aria-modal="true"
                style={{ display: "block" }}
                role="dialog"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  style={{ maxWidth: 350 }}
                >
                  <div className="modal-content">
                    <div className="modal-header justify-content-center">
                      <h4 className="modal-title fs-5" id="session-expired">
                        Your session is expired!
                      </h4>
                    </div>
                    <div className="modal-body text-center">
                      <button
                        className="fill-btn fw-600"
                        onClick={() => handleSearchAgain()}
                      >
                        Search Again
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default ReviewBookingNew;
